import { useUsersMap } from '../hooks/useUsersMap';

/**
 * UserBadge — shows a small avatar + first name for the given userId.
 * size: 'sm' (default) | 'xs'
 */
export function UserBadge({ userId, size = 'sm', showName = true }) {
  const usersMap = useUsersMap();
  if (!userId) return null;

  const user = usersMap[userId];
  const name = user?.name || user?.email?.split('@')[0] || '?';
  const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  const color = user?.color || 'bg-muted-foreground/40';
  const firstName = name.split(' ')[0];

  if (size === 'xs') {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] text-muted-foreground">
        <span className={`w-3.5 h-3.5 rounded-full ${color} text-white flex items-center justify-center text-[8px] font-bold flex-shrink-0`}>
          {initials[0]}
        </span>
        {showName && <span className="truncate max-w-[80px]">{firstName}</span>}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground whitespace-nowrap">
      <span className={`w-5 h-5 rounded-full ${color} text-white flex items-center justify-center text-[9px] font-bold flex-shrink-0`}>
        {initials}
      </span>
      {showName && <span className="truncate max-w-[100px]">{firstName}</span>}
    </span>
  );
}
